module.exports = __webpack_public_path__ + "img/Reading.feffae1b.svg";